export function appendUniqueFilterValue<T>(value: Array<T>, selectedValue: T): Array<T> {
  return value.includes(selectedValue) ? value : [...value, selectedValue];
}
